/**
 * @generated SignedSource<<0d4369f19f2aa2d86b1af0d493510b82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

var node = function () {
  var v0 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v1 = {
      "kind": "ScalarField",
      "name": "type"
    };
  return {
    "argumentDefinitions": [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forgeExtensionRenderingContext"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "uiModificationsContext"
    }],
    "kind": "Fragment",
    "name": "fragment_AtlassianUiModificationsCore_RootFragment",
    "selections": [{
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [{
        "kind": "RequiredField",
        "field": {
          "args": [{
            "kind": "Variable",
            "name": "context",
            "variableName": "uiModificationsContext"
          }],
          "concreteType": "JiraAppUiModifications",
          "kind": "LinkedField",
          "name": "uiModifications",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "name": "appEnvId"
          }, {
            "concreteType": "JiraUiModification",
            "kind": "LinkedField",
            "name": "uiModifications",
            "plural": true,
            "selections": [v0 /*: any*/, {
              "kind": "ScalarField",
              "name": "data"
            }]
          }]
        },
        "action": "NONE",
        "path": "jira.uiModifications"
      }, {
        "concreteType": "JiraForgeQuery",
        "kind": "LinkedField",
        "name": "forge",
        "plural": false,
        "selections": [{
          "kind": "RequiredField",
          "field": {
            "alias": "uiModificationsExtensions",
            "args": [{
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }, {
              "kind": "Variable",
              "name": "context",
              "variableName": "forgeExtensionRenderingContext"
            }, {
              "kind": "Literal",
              "name": "types",
              "value": ["jira:uiModifications"]
            }],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [v0 /*: any*/, {
              "kind": "ScalarField",
              "name": "appVersion"
            }, {
              "kind": "ScalarField",
              "name": "installationId"
            }, {
              "kind": "ScalarField",
              "name": "environmentId"
            }, {
              "kind": "ScalarField",
              "name": "environmentType"
            }, {
              "kind": "ScalarField",
              "name": "environmentKey"
            }, {
              "concreteType": "JiraForgeExtensionLicense",
              "kind": "LinkedField",
              "name": "license",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "active"
              }, v1 /*: any*/, {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
              }, {
                "kind": "ScalarField",
                "name": "trialEndDate"
              }, {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
              }, {
                "kind": "ScalarField",
                "name": "isEvaluation"
              }, {
                "kind": "ScalarField",
                "name": "billingPeriod"
              }, {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
              }, {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
              }, {
                "kind": "ScalarField",
                "name": "capabilitySet"
              }]
            }, {
              "kind": "ScalarField",
              "name": "properties"
            }, {
              "kind": "ScalarField",
              "name": "scopes"
            }, v1 /*: any*/, {
              "concreteType": "JiraForgeAppEgressDeclaration",
              "kind": "LinkedField",
              "name": "egress",
              "plural": true,
              "selections": [v1 /*: any*/, {
                "kind": "ScalarField",
                "name": "addresses"
              }, {
                "kind": "ScalarField",
                "name": "category"
              }, {
                "kind": "ScalarField",
                "name": "inScopeEUD"
              }]
            }, {
              "concreteType": "JiraForgeInstallationConfigExtension",
              "kind": "LinkedField",
              "name": "installationConfig",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "name": "key"
              }, {
                "kind": "ScalarField",
                "name": "value"
              }]
            }, {
              "kind": "ScalarField",
              "name": "consentUrl"
            }, {
              "concreteType": "JiraUserAppAccess",
              "kind": "LinkedField",
              "name": "userAccess",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "hasAccess"
              }, {
                "kind": "ScalarField",
                "name": "enabled"
              }]
            }, {
              "kind": "ScalarField",
              "name": "hiddenBy"
            }]
          },
          "action": "NONE",
          "path": "jira.forge.uiModificationsExtensions"
        }]
      }]
    }],
    "type": "Query"
  };
}();
node.hash = "ff48dbe4ed2ab636d857ff6d8fc8b30f";
export default node;